import ActivityLog from '@/components/ui/ActivityLog'
import {
    getServiceCaseStatus,
    getServiceCaseType,
    getHandlingLocation,
} from '@/lib/serviceCaseStatuses'

const formatChip = (field, value) => {
    if (field === 'status') {
        const s = getServiceCaseStatus(value)
        return {
            label: s.label,
            className: `${s.classes.bg} ${s.classes.text} border ${s.classes.border}`,
        }
    }
    if (field === 'type') return { label: getServiceCaseType(value).label }
    if (field === 'is_handled_by') return { label: getHandlingLocation(value).label }
}

const getEntryLabel = (activity) => {
    if (activity.event === 'email_sent') return 'Email envoyé au client'
    if (activity.subject_type !== 'intervention') return null

    const name = activity.intervention_name
        ? `Intervention « ${activity.intervention_name} »`
        : 'Intervention'
    if (activity.event === 'created') return `${name} ajoutée`
    if (activity.event === 'updated') {
        const changes = activity.attribute_changes
        if (changes?.attributes?.canceled_at) return `${name} annulée`
        if (changes?.attributes?.price_cents !== undefined) return `${name} — tarif modifié`
    }
    return name
}

export default function ServiceCaseHistory({ serviceCaseId }) {
    return (
        <ActivityLog
            subjectType="service-cases"
            subjectId={serviceCaseId}
            formatChip={formatChip}
            getEntryLabel={getEntryLabel}
        />
    )
}
